<template>
  <div>
    <div class="mw-1380 mx-auto mt-100 c-project">
      <div class="grid-2 grid-col-gap-60 min-vh">
        <h2>Page not found</h2>
        <div>
          <p> It's possible that the page has been moved, deleted, or the URL was mistyped. Please check the URL and try again, or use the navigation menu to find the content you're looking for.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NotFound',
  components: {
  },
}
</script>
